export function FormatEmojii(emoji) {
  if (!emoji) return "";
  return emoji.replace(
    /\\u\{([0-9a-fA-F]+)\}|\\u([0-9a-fA-F]{4})/g,
    (_, bracedHex, shortHex) =>
      String.fromCodePoint(parseInt(bracedHex || shortHex, 16))
  );
}
